import { AnnotationView } from "@/features/annotation";
import { TimelineDataProvider } from "@/features/annotation/hooks/useTimelineData";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { NavigationItems } from "@/shared/types/navigation";
import { PlayerProvider } from "@/shared/components/PlayerProvider";

export function Annotation() {
  useDocumentTitle(NavigationItems.LOD.name);

  return (
    <TimelineDataProvider>
      <PlayerProvider>
        <AnnotationView />
      </PlayerProvider>
    </TimelineDataProvider>
  );
}
